var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ScreenSpec" },
    [
      _c("TheHeader", {
        attrs: { editable: _vm.editable, toRoot: _vm.toRoot },
        on: {
          openTreeDialog: _vm.onOpenTreeDialog,
          createNewFile: _vm.onCreateNewFile
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "Spec" },
        [
          _c("Screen", {
            attrs: {
              editable: _vm.editable,
              width: _vm.screenWidth,
              screen: _vm.screen,
              svgCanvasHtml: _vm.svgCanvasHtml
            },
            on: { openScreenEditor: _vm.onOpenScreenEditor }
          }),
          _vm._v(" "),
          _c("Separator", { on: { drag: _vm.onSeparatorDrag } }),
          _vm._v(" "),
          _c("Doc", {
            attrs: {
              editable: _vm.editable,
              width: _vm.documentWidth,
              convertedHtml: _vm.convertedHtml,
              updatedDate: _vm.updatedDate,
              updatedAuthorName: _vm.updatedAuthorName,
              createdDate: _vm.createdDate,
              createdAuthorName: _vm.createdAuthorName
            },
            on: { openTreeDialog: _vm.onOpenTreeDialog }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "OverlayScreen",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isShowTreeDialog,
              expression: "isShowTreeDialog"
            }
          ],
          on: { close: _vm.onCloseTreeDialog }
        },
        [
          _c(
            "BaseDialog",
            {
              attrs: { overflowScroll: true },
              on: { close: _vm.onCloseTreeDialog }
            },
            [
              _c(
                "div",
                { attrs: { slot: "main" }, slot: "main" },
                [
                  _c("Tree", {
                    attrs: {
                      treeData: _vm.treeData,
                      toRoot: _vm.toRoot,
                      currentPathFromRoot: _vm.currentPathFromRoot,
                      callback: _vm.callback
                    },
                    on: { closeTreeDialog: _vm.onCloseTreeDialog }
                  })
                ],
                1
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "OverlayScreen",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isShowScreenEditor,
              expression: "isShowScreenEditor"
            }
          ],
          on: { close: _vm.onCloseScreenEditor }
        },
        [
          _c(
            "BaseDialog",
            {
              staticClass: "Spec_ScreenEditorDialog",
              attrs: { overflowScroll: true },
              on: { close: _vm.onCloseScreenEditor }
            },
            [
              _c(
                "div",
                {
                  staticStyle: { height: "100%" },
                  attrs: { slot: "main" },
                  slot: "main"
                },
                [
                  _c("ScreenEditor", {
                    attrs: { screen: _vm.screen },
                    on: {
                      updateFilenameWithCoordinates:
                        _vm.onUpdateFilenameWithCoordinates,
                      updateFileToUpload: _vm.onUpdateFileToUpload
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.editable
                ? _c(
                    "div",
                    {
                      staticClass: "Spec_ScreenEditorDialogActionBar",
                      attrs: { slot: "footer" },
                      slot: "footer"
                    },
                    [
                      _c("ActionButton", { attrs: { sub: true } }, [
                        _c("span", { on: { click: _vm.onCloseScreenEditor } }, [
                          _vm._v("Cancel")
                        ])
                      ]),
                      _vm._v(" "),
                      _c("ActionButton", [
                        _c(
                          "span",
                          { on: { click: _vm.onWriteScreenMetadata } },
                          [_vm._v("Save")]
                        )
                      ])
                    ],
                    1
                  )
                : _vm._e()
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("PortalTarget", { attrs: { name: "uploadScreenImageDialog" } }),
      _vm._v(" "),
      _c("PortalTarget", { attrs: { name: "uploadDocumentImageDialog" } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }